module.exports = __webpack_public_path__ + "static/scr-ios-dcd1cbe7a8cbd45b87894cee26bf9527.png";